import React from "react";
import { Link } from "react-router-dom";
import Yoga from "./Yoga";
import { Breadcrumbs } from "./../../Breadcrumb/index";

const YogaProduct = () => {
  return (
    <div className="productPage">
      <div class="container py-5">
        <div class="row">
          <div class="col-lg-12">
            <div class="row">
              <Breadcrumbs currentPathName="Weight Gain" />
              <div class="col-md-6">
                <ul class="list-inline shop-top-menu pb-3 pt-1">
                  <li class="list-inline-item">
                    <Link
                      class="h3 text-dark text-decoration-none mr-3 text-uppercase"
                      to="/yogaProduct"
                    >
                      Weight Gain
                    </Link>
                  </li>
                </ul>
              </div>
            </div>
            <div class="row">
              <Yoga />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default YogaProduct;
